// ContactBinder.jsx
import React, { useEffect, useState } from "react";
import SocialsBar from "./SocialsBar";
import JsonService from "./JsonService";

export default function ContactBinder({
  content_url = "/sections/contact.json",
  className = "",
  style = {}
}) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    const ctrl = new AbortController();
    (async () => {
      try {
        const j = await JsonService.fetchJson({
          url: content_url,
          signal: ctrl.signal,
          cache: "no-store",
        });

        // Accept either "socials_bar" or "contact_binder"
        if (j?.render_control_type === "socials_bar" || j?.render_control_type === "contact_binder") {
          setCfg({ items: j.items || [], label: j.label || "contact:" });
        } else if (Array.isArray(j?.items)) {
          // tolerate bare { items, label }
          setCfg({ items: j.items, label: j.label || "contact:" });
        } else {
          console.warn("ContactBinder: unexpected JSON shape at", content_url, j);
          setCfg(null);
        }
      } catch (e) {
        console.warn("ContactBinder load failed:", e);
        setCfg(null);
      }
    })();
    return () => ctrl.abort();
  }, [content_url]);

  if (!cfg) return null;

  return (
    <div className={className} style={style}>
      <SocialsBar items={cfg.items} label={cfg.label} />
    </div>
  );
}
